import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDataAPI, postDataAPI, putDataAPI } from "../../utils/FetchData";
import { setErrorAlert, setLoader, setSuccessAlert } from "../alert/alertSlice";
import { sync_data_thunk } from "../auth/authThunk";
import {
  DEFAULT_SHORTCUTS,
  isMacOS,
  WINDOWS_DEFAULT_SHORTCUTS,
} from "../../common/common";
let defaultOsShortcuts = isMacOS()
? DEFAULT_SHORTCUTS
: WINDOWS_DEFAULT_SHORTCUTS;

// Helper function to get category for a shortcut ID
const getShortcutCategory = (shortcutId) => {

  for (const [category, shortcuts] of Object.entries(defaultOsShortcuts)) {
    if (shortcuts.some((s) => s.id === shortcutId)) {
      return category;
    }
  }
  return null;
};

// Helper function to get default shortcut by ID
const getDefaultShortcut = (shortcutId) => {
  for (const shortcuts of Object.values(defaultOsShortcuts)) {
    const shortcut = shortcuts.find((s) => s.id === shortcutId);
    if (shortcut) return shortcut;
  }
  return null;
};

export const update_shortcuts_thunk = createAsyncThunk(
  "user/shortcut/update_shortcut",
  async (tempData, thunkAPI) => {
    try {
      let body = {
        shortcuts: tempData.data.shortcuts,
        windowsShortcuts: tempData.data.windowsShortcuts,
      };
      await postDataAPI("user/shortcut/update_shortcut", body, tempData.token);
      if (tempData?.call) {
        thunkAPI.dispatch(get_shortcut_thunk({ token: tempData.token }));
      }
      return;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(sync_data_thunk({ token: tempData.token }));
      thunkAPI.dispatch(
        setErrorAlert(
          error?.response?.data?.message ||
            "The data is not stored because your network is offline"
        )
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message ||
          "The data is not stored because your network is offline"
      );
    }
  }
);
export const get_shortcut_thunk = createAsyncThunk(
  "user/shortcut/get_shortcuts",
  async (tempData, thunkAPI) => {
    try {
      const response = await getDataAPI(
        "user/shortcut/get_shortcuts",
        tempData.token
      );
      let osShortcuts = isMacOS()
        ? response.data.data.shortcuts || {}
        : response.data.data.windowsShortcuts || {};

      localStorage.setItem(`shortCuts`, JSON.stringify(osShortcuts));
      let defaultOsShortcuts = isMacOS()
        ? DEFAULT_SHORTCUTS
        : WINDOWS_DEFAULT_SHORTCUTS;
      const defaultShortcutIds = Object.values(defaultOsShortcuts)
        .flat()
        .map((shortcut) => shortcut.id);

      const responseShortcuts = osShortcuts || {};

      const responseShortcutIds = Object.entries(responseShortcuts).reduce(
        (ids, [category, shortcuts]) => {
          // Check if shortcuts is an array (for safety)
          const categoryShortcuts = Array.isArray(shortcuts)
            ? shortcuts.map((shortcut) => shortcut.id)
            : [];
          return [...ids, ...categoryShortcuts];
        },
        []
      );

      // Get response shortcuts object
      const missingShortcuts = defaultShortcutIds.filter(
        (id) => !responseShortcutIds.includes(id)
      );

      const invalidShortcuts = responseShortcutIds.filter(
        (id) => !defaultShortcutIds.includes(id)
      );

      if (missingShortcuts.length > 0 || invalidShortcuts.length > 0) {
        const updatedShortcuts = { ...responseShortcuts };

        // Remove invalid shortcuts from each category
        Object.keys(updatedShortcuts).forEach((category) => {
          if (Array.isArray(updatedShortcuts[category])) {
            updatedShortcuts[category] = updatedShortcuts[category].filter(
              (shortcut) => !invalidShortcuts.includes(shortcut.id)
            );
          }
        });

        // Add missing shortcuts to their respective categories
        missingShortcuts.forEach((shortcutId) => {
          const category = getShortcutCategory(shortcutId);
          const defaultShortcut = getDefaultShortcut(shortcutId);

          if (category && defaultShortcut) {
            // Initialize category array if it doesn't exist
            if (!updatedShortcuts[category]) {
              updatedShortcuts[category] = [];
            }

            // Add the missing shortcut to its category
            updatedShortcuts[category].push(defaultShortcut);
          }
        });

        let isMac = isMacOS();
        let data;
        if (isMac) {
          data = {
            shortcut: updatedShortcuts,
            windowsShortcuts: osShortcuts,
          };
        } else {
          data = {
            shortcut: osShortcuts,
            windowsShortcuts: updatedShortcuts,
          };
        }

        thunkAPI.dispatch(
          update_shortcuts_thunk({
            data: data,
            token: tempData.token,
            call: true,
          })
        );
      }

      return response.data;
    } catch (error) {
      console.log("error", error);
      // thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'The data is not stored because your network is offline'));
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message ||
          "The data is not stored because your network is offline"
      );
    }
  }
);
